import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GameProvider } from "./Context/GameContext";
import { DifficultyRatingsProvider } from "./Context/DifficultyRatingsContext";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from "./Config/config";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element with id 'root' not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <GameProvider>
        <DifficultyRatingsProvider>
          <App />
        </DifficultyRatingsProvider>
      </GameProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
